export const initialStateFilter = {
  colorFilters: [
    {
      label: 'Weiß',
      imgUrl: 'https://cdn.shopify.com/s/files/1/0098/6044/8292/files/color-cream.png',
      colors: [`Weiß`, `weiß`, `schneeweiß`, `gebrochenes weiß`, `tofu`, `elfenbein weiß`, `whisper white`],
      checked: false,
      checkColor: 'black',
    },
    {
      label: 'Taupe',
      imgUrl: 'https://cdn.shopify.com/s/files/1/0098/6044/8292/files/color-sand.png',
      colors: [
        `Taupe`,
        `beige`,

        `whitecap grau`,
        `pargament`,
        `tapioka`,
        `crème brûlée`,
        `sandshell`,
        `wintermodus`,
        `nebel`,
        `warmes gray`,

        `light taupe`,
        `feder grau`,
        `plaza taupe`,
        `taupe`,

        `satellit`,
        `kakao`,

        `türkisch kaffee`,
        `buttercream`,
        'shitake',
        'otter',
        'falcon',
        'nomad',
        'almond milk',
      ],
      checked: false,
      checkColor: 'white',
    },
    {
      label: 'Gelb',
      imgUrl: 'https://cdn.shopify.com/s/files/1/0098/6044/8292/files/color-lemon.png',
      colors: [
        `Gelb`,
        `french vanilla`,
        `pale banana`,
        `golden haze`,
        `gelb`,
        `daffodil`,
        `eigelb gelb`,
        `senf`,

        `citronelle`,
        `senfgold`,
        `peach nougat`,
        `sonnenorange`,
        `rotorange`,
        `kapuzinerkresse`,
        `tigerlilie`,
        `apricot`,
        'solar power',
        'yellow iris',
      ],
      checked: false,
      checkColor: 'white',
    },
    {
      label: 'Rosa',
      imgUrl: 'https://cdn.shopify.com/s/files/1/0098/6044/8292/files/color-pink.png',
      colors: [
        `Rosa`,
        `rosenwasser`,
        `blütenrosa`,
        `pearl blush`,
        `altrosa`,
        `errötend`,
        `fingerhut`,
        `blass lila`,
        `mauve chalk`,
        `rose smoke`,
        `lehmziegelrosa`,
        `holzrose`,
        `lilac`,

        `aschenrosa`,

        `Old rose`,
        `pale mauve`,
        `traubenshake`,
        `rosa braun`,
        `dunkelviolett`,
        `rum rosine`,
        `fuchsie rosa`,
        `bright rose`,
        `himbeer strahlen`,
        `beaujolais`,
        `tibet rot`,
        `paradiesrosa`,
        `puderrosa`,

        `orchideeneis`,

        `orchidee hush`,
        `orchid bloom`,
        `orchid bouquet`,
        `lavendelfrost`,
        `sandstein`,
        `lavendelgrau`,
        `grape jam`,
        `süßtraube`,
        `pflaume perfekt`,
        `Bellflower`,
        'cherries jubilee',
        'pale dogwood',
        'foxglove',
        'bubblegum',
        'winetasting',
        'peach blossom',
        'chalk violet',
        'lila weingummi',
        'heirloom lilac',
        'deep periwinkle',
        'almond blossom',
        'zephyr',
      ],
      checked: false,
      checkColor: 'white',
    },
    {
      label: 'Rot',
      imgUrl: 'https://cdn.shopify.com/s/files/1/0098/6044/8292/files/color-reddish.png',
      colors: [
        `rot`,
        `lachs`,

        `garnele`,
        `burnt coral`,
        `fusion coral`,
        `koralle`,
        `tangerine tango`,
        `muschelrosa`,
        `cayenne`,

        `scharlachrot`,
        `würzige orange`,
        `feurig rot`,
        `rot`,

        `racing red`,
        `ribbon red`,
        `rose red`,
        `berberitze`,
        `haute rot`,

        `erdenrot`,
        `verbrannter ziegel`,
        `tandoori gewürz`,
        `red clay`,
        `verbrannter ocker`,
        `verbrannte henna`,
        `crushed berry`,
        `bordeaux`,

        `rhododendron`,
        `cabernet`,

        `krappbraun`,
        `cowhide`,
        `sassafras`,
        `bitter chocolate`,
        `black plum`,
        'aurora red',
        'chili',
      ],
      checked: false,
      checkColor: 'black',
    },
    {
      label: 'Grau',
      imgUrl: 'https://cdn.shopify.com/s/files/1/0098/6044/8292/files/color-grey.png',
      colors: [
        'antarktika',
        'mikrochip',
        'weißgrau',
        'hellgrau',
        'hafennebel',
        'paloma',
        'haifischhaut',
        'steingrau',
        'neutral grau',
        'schwachgrau',
        'holzkohle',
        'schiefer',
        'vapor blue',
        'gray morn',
        'storm front',
      ],
      checked: false,
      checkColor: 'black',
    },
    {
      label: 'Grün',
      imgUrl: 'https://cdn.shopify.com/s/files/1/0098/6044/8292/files/color-green.png',
      colors: [
        `Grün`,
        `whisper blau`,
        `clearly aqua`,
        `blasses aqua`,
        `grauer nebel`,
        `jadegrün`,

        `arktisch blau`,
        `abyss`,
        `slate`,
        `altgrün`,
        `deep lake`,
        `teal grün`,
        `shady glade`,
        `atlantische tiefe`,
        `agavengrün`,
        `capulet olive`,
        `sea spray`,
        `bronzegrün`,
        `trekking grün`,
        `jane bug`,
        `seemoos`,
        `dunkelgrün`,
        `greener pastures`,
        `kombu grün`,
        `dunkle olive`,
        'opal',
        'cypress',
        'teal',
        'vetivergras',
        'loden frost',
      ],
      checked: false,
      checkColor: 'white',
    },
    {
      label: 'Marineblau',
      imgUrl: 'https://cdn.shopify.com/s/files/1/0098/6044/8292/files/color-marine.png',
      colors: [
        `Marineblau`,
        `arktisches eis`,
        `gray dawn`,
        `distel`,
        `brunnera blau`,
        `altlavendel`,
        `blau iris`,
        `surf the web`,
        `blueprint`,
        `sodalithblau`,
        `nachtschatten blau`,
        `kronenblau`,
        `peacoat`,
        `deepwell`,
        `mitternacht`,
        `illusion blau`,
        `himmelweg`,
        `hellblau`,
        `chambray blue`,
        `luftblau`,
        `blau`,

        `blauer granit`,
        `purple impression`,
        `englischer manor`,
        `ultramarin`,

        `bijou blau`,
        `marine pfingstrose`,
        `black iris`,
        `marineblau`,

        `baby blau`,
        `blaues glas`,
        `canal blue`,
        `delphinium blue`,
        `dusty blue`,
        `blaues himmel`,
        `coronet blau`,
        `blithe`,
        `hawaiian ocean`,
        `karibisches meer`,
        `mosaic blue`,
        `pfau`,
        `marokkanisch blau`,
        `ensign blau`,
        `majolika blau`,
        `ebony`,
        `eklipse`,
        'winter sky',
        'navy blazer',
        'starlight blue',
        'twilight blue',
        'copen blue',
        'dress blues',
        'poseidon',
      ],
      checked: false,
      checkColor: 'white',
    },
    {
      label: 'Braun',
      imgUrl: 'https://cdn.shopify.com/s/files/1/0098/6044/8292/files/color-brown.png',
      colors: [
        `Braun`,
        `caramel cream`,
        `ginger root`,
        `hellkamel`,

        `toasted almond`,
        `schaffell`,
        `rehbock`,
        `gelbbraun`,
        `mandel`,

        `pumpkin spice`,
        `kamel`,

        `mokka`,
        `leather brown`,
        `sequoia`,
        `twilight mauve`,
        `tief taupe`,
        `andorra`,
        `shopping bag`,
        `decadent-chocolate`,
        `java`,
        `schokoladenbraun`,
        `coffee bean`,
        'molé',
        'sugar almond',
        'cabernet',
      ],
      checked: false,
      checkColor: 'white',
    },
    {
      label: 'Schwarz',
      imgUrl: 'https://cdn.shopify.com/s/files/1/0098/6044/8292/files/color-black.png',
      colors: [
        `Schwarz`,
        `schwarz`,

        `Grau`,
        `antarktika`,
        `mikrochip`,
        `weißgrau`,

        `hellgrau`,

        `hafennebel`,
        `paloma`,
        `tradewinds`,
        `haifischhaut`,
        `steingrau`,

        `neutral grau`,
        `schwachgrau`,

        `holzkohle`,

        `schiefer`,
      ],
      checked: false,
      checkColor: 'white',
    },
    {
      label: 'Multi Color',
      focus: 'tag',
      imgUrl: 'https://cdn.shopify.com/s/files/1/1953/2845/files/multi-color.png?v=1597637857',
      tags: ['multicolor'],
      checked: false,
      checkColor: 'white',
    },
  ],
  sizeFilters: [
    {
      label: 'ONE SIZE',
      size: ['One Size'],
      checked: false,
      position: 1,
    },
    {
      label: '2XS',
      size: ['2XS'],
      checked: false,
      position: 2,
    },
    {
      label: 'XS',
      size: ['XS', '2XS - XS'],
      checked: false,
      position: 3,
    },
    {
      label: 'S',
      size: ['S', 'XS - S'],
      checked: false,
      position: 4,
    },
    {
      label: 'M',
      size: ['M', 'S - M'],
      checked: false,
      position: 5,
    },
    {
      label: 'L',
      size: ['L', 'M - L'],
      checked: false,
      position: 6,
    },
    {
      label: 'XL',
      size: ['XL', 'L - XL'],
      checked: false,
      position: 7,
    },
    {
      label: '2XL',
      size: ['2XL', 'XL - 2XL'],
      checked: false,
      position: 8,
    },
    {
      label: '3XL',
      size: ['3XL'],
      checked: false,
      position: 9,
    },
    {
      label: '4XL',
      size: ['4XL'],
      checked: false,
      position: 10,
    },
  ],
  categoriesFilters: [],
  sortFilters: [
    // {
    //   label: 'New',
    //   checked: false,
    //   id:"new"
    // },
    {
      label: 'Price Low - High',
      checked: false,
      id: 'price_asc',
    },
    {
      label: 'Price High - Low',
      checked: false,
      id: 'price_desc',
    },
  ],
  priceFilters: [
    {
      start: 0,
      end: 100,
      checked: false,
      label: '0:100',
    },
    {
      start: 100,
      end: 200,
      checked: false,
      label: '100:200',
    },
    {
      start: 200,
      end: 300,
      checked: false,
      label: '200:300',
    },
    {
      start: 300,
      // end: "",
      checked: false,
      label: '300:',
    },
  ],
};

export function makeId(length) {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
